import {Injectable} from '@angular/core';

@Injectable()
export class WindowProvider {
  public get(): Window {
    return <any>window;
  }
}
